import React from 'react'
import HeaderSix from '../header/HeaderSix'
import FooterSix from '../footer/FooterSix'

const Layout = ({ children }) => {
  return (
    <>
    
<HeaderSix/>
{ children }
<FooterSix/>

    </>
  )
}

export default Layout
